import { setLoaderApp } from "store/loader/loaderSlice";
import axiosInstance from "./axiosConfig";
import { loaderStore } from "store/loader/loaderStore";
/* -------------------------------------------------------------------------- */
const setLoading = setLoaderApp;
const dispatch = loaderStore.dispatch;

export const uploadAPI = (
  file,
  uploadProgress,
  is_public,
  is_airline_public
) => {
  let formData = new FormData();
  formData.append("file", file);
  if (is_public !== undefined) {
    formData.append("is_public", is_public);
  }
  if (is_airline_public !== undefined) {
    formData.append("is_airline_public", is_airline_public);
  }
  let percentCompleted = 0;
  let configObj = {
    timeout: 300000,
    headers: {
      "Content-Type": "multipart/form-data",
      design: "Enroute Backoffice",
    },
    onUploadProgress: (progressEvent) => {
      if (uploadProgress) {
        if (progressEvent.total) {
          percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
        console.warn({ percentCompleted });
        uploadProgress(percentCompleted);
      }
    },
  };
  dispatch(setLoading(true));

  return axiosInstance
    .post("filemanager/upload", formData, configObj)
    .then((res) => {
      dispatch(setLoading(false));

      return res;
    })
    .catch((err) => {
      dispatch(setLoading(false));
      let errorCode = 0;
      let result_number = null;
      if (err?.response?.status) {
        errorCode = err.response.status;
      }
      if (err?.response?.data) {
        result_number = err.response.data.result_number;
      }
      return Promise.reject({
        ecode: "Services:APIs:File:Upload:2",
        err,
        errorCode,
        result_number,
      });
    });
};
/* -------------------------------------------------------------------------- */
export const uploadMultipleAPI = (
  files,
  uploadProgress,
  is_public,
  is_airline_public
) => {
  let formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });
  formData.append("is_public", is_public);
  if (is_airline_public !== undefined) {
    formData.append("is_airline_public", is_airline_public);
  }

  let percentCompleted = 0;
  let configObj = {
    timeout: 300000,
    headers: {
      "Content-Type": "multipart/form-data",
      design: "Enroute Backoffice",
    },
    onUploadProgress: (progressEvent) => {
      if (uploadProgress) {
        if (progressEvent.total) {
          percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
        uploadProgress(percentCompleted);
      }
    },
  };

  dispatch(setLoading(true));

  return axiosInstance
    .post("filemanager/upload-multiple", formData, configObj)
    .then((res) => {
      dispatch(setLoading(false));
      return res.data;
    })
    .catch((err) => {
      dispatch(setLoading(false));
      let errorCode = 0;
      let result_number = null;
      if (err?.response?.status) {
        errorCode = err.response.status;
      }
      if (err?.response?.data) {
        result_number = err.response.data.result_number;
      }
      return Promise.reject({
        ecode: "Services:APIs:File:Upload:2",
        err,
        errorCode,
        result_number,
      });
    });
};
/* -------------------------------------------------------------------------- */
export const downloadFileAPI = (fileId) => {
  dispatch(setLoading(true));
  return axiosInstance
    .get(`filemanager/download/public/${fileId}`, {
      responseType: "blob",
      headers: {
        design: "Enroute Backoffice",
      },
    })
    .then((res) => {
      dispatch(setLoading(false));

      return res.data;
    })
    .catch((err) => {
      dispatch(setLoading(false));
      let errorCode = 0;
      let result_number = null;
      if (err?.response?.status) {
        errorCode = err.response.status;
      }
      if (err?.response?.data) {
        result_number = err.response.data.result_number;
      }
      let errorResponse = {
        ecode: "Services:APIs:File:Upload:2",
        err,
        errorCode,
        result_number,
      };
      throw errorResponse;
    });
};
/* -------------------------------------------------------------------------- */
